module.exports = "/_next/static/images/UDJ2-27aee7680377f3f1cd46548b7c94684e.svg";